import { useEffect, useRef, useState } from "react";
import { Play } from "lucide-react";
import { cn } from "@/lib/utils";

const reducedMotion = () =>
    typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const VideoPlayer = ({
    src, srcMobile, poster, fallbackImg, className, videoClassName,
    autoPlay = true, controls = false, label = "Concept visualization footage", testid,
}) => {
    const wrap = useRef(null);
    const [active, setActive] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        const ob = new IntersectionObserver(
            ([e]) => { if (e.isIntersecting) { setActive(true); ob.disconnect(); } },
            { rootMargin: "320px" }
        );
        if (wrap.current) ob.observe(wrap.current);
        return () => ob.disconnect();
    }, []);

    const showVideo = src && !failed && !reducedMotion();

    return (
        <div ref={wrap} className={cn("relative overflow-hidden bg-omsivo-deep", className)} data-testid={testid}>
            {showVideo && active ? (
                <video
                    className={cn("h-full w-full object-cover", videoClassName)}
                    muted
                    loop
                    playsInline
                    autoPlay={autoPlay}
                    controls={controls}
                    preload="metadata"
                    poster={poster}
                    aria-label={label}
                    onError={() => setFailed(true)}
                >
                    {srcMobile && <source src={srcMobile} media="(max-width: 768px)" type="video/mp4" />}
                    <source src={src} type="video/mp4" />
                </video>
            ) : (
                (poster || fallbackImg) && (
                    <img src={poster || fallbackImg} alt={label} loading="lazy"
                        className={cn("h-full w-full object-cover", videoClassName)} />
                )
            )}
            {!src && !poster && !fallbackImg && (
                <div className="flex h-full min-h-[220px] flex-col items-center justify-center gap-3">
                    <span className="flex h-14 w-14 items-center justify-center rounded-full border border-white/20 bg-white/5">
                        <Play className="h-6 w-6 text-flame" />
                    </span>
                    <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/50">Concept video coming soon</p>
                </div>
            )}
        </div>
    );
};
